<template>
  <div class="container sxsw-scraper index">
    <h1 class="title">SXSW Scraper</h1>

    <div class="section events">
      <h2>Events
        <small v-if="!loading" class="text-muted">All {{events.length}} of them </small>
        <small v-else>loading...</small>
        <button v-if="!loading" @click.stop.prevent="onExportKeywordsList()" class="btn btn-outline-info btn-sm" >Export Keywords</button>
        <button v-if="!loading" @click.stop.prevent="onExportBlockList()" class="btn btn-outline-info btn-sm" >Export Blocklist</button>
      </h2>

      <div class="row">
        <div class="col">
          <!-- <pre>{{ events }}</pre> -->
          <SxswEvent v-for="evt in events" :key="evt.event_id" :evt="evt" :keywords="keywords[evt.event_id]"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './../style/sxswScraper.scss'
// import { mapState } from 'vuex'
// import axios from 'axios'
// import moment from 'moment'
import Vue from 'vue'
import SxswEvent from './../components/SxswEvent.vue'
// import { ToggleButton } from 'vue-js-toggle-button'
import { tokenMixin } from 'rph-slides-vue/src/mixins/tokenMixin.js'

export default {
  name: 'SxswEventIndex',
  components: { SxswEvent },
  mixins: [tokenMixin],
  data () {
    return {
      count: 0,
      events: [],
      keywords: {},
      blocklist: {},
      loading: false
    }
  },
  computed: {},
  created () {
    this.$socket.emit('/sxswscraper/events', { order: 'asc' }, this.onEventsUpdate.bind(this))
    this.$socket.on('/sxswscraper/keywords', this.onKeywordsUpdate.bind(this))
    this.$socket.emit('/sxswscraper/keywords', this.onKeywordsUpdate.bind(this))
    this.$socket.on('/sxswscraper/block', this.onBlocksUpdate.bind(this))
    this.$socket.emit('/sxswscraper/block', this.onBlocksUpdate.bind(this))
    this.loading = true
  },
  methods: {
    onBlocksUpdate (resp) {
      // console.log(resp)
      if (resp.status.code === 200) {
        this.blocklist = resp.data
        // this.events.forEach(evt => {
        for (let i = 0; i < this.events.length; i += 1) {
          // console.log(this.events[i].event_id)
          const value = ({}).hasOwnProperty.call(resp.data, this.events[i].event_id) ? resp.data[this.events[i].event_id] : false
          Vue.set(this.events[i], 'block', value)
          // evt.block = ({}).hasOwnProperty.call(resp.data, evt.event_id) ? resp.data[evt.event_id] : false
        }
      } else {
        console.log(resp)
      }
    },
    onEventsUpdate (resp) {
      if (resp.status.code === 200) {
        // console.log('onEventsUpdate', resp)
        // for (let i = 0; i < resp.data.length; i += 1) {
        //   const a = resp.data[i].sxswId.split('/')
        //   resp.data[i].sxswCleanId = a[a.length - 1]
        // }
        this.events = resp.data
      } else {
        console.log(resp)
      }
      this.loading = false
    },
    onKeywordsUpdate (resp) {
      // console.log('onKeywordsUpdate', resp)
      if (resp.status.code === 200) {
        this.keywords = resp.data
      } else {
        console.log(resp)
      }
    },
    onExportKeywordsList () {
      const timeStr = new Date().toISOString().replace(/:/g, '-')
      const blob = new Blob([JSON.stringify(this.keywords, null, 2)], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'sxswKeywords_' + timeStr + '.json'
      link.click()
      URL.revokeObjectURL(link.href)
    },
    onExportBlockList () {
      const timeStr = new Date().toISOString().replace(/:/g, '-')
      const blob = new Blob([JSON.stringify(this.blocklist, null, 2)], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'sxswBlocklist_' + timeStr + '.json'
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>
